import { render, staticRenderFns } from "./store-settings.vue?vue&type=template&id=3f746a23&"
import script from "./store-settings.vue?vue&type=script&lang=js&"
export * from "./store-settings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports